import { ListItemButton, Stack, Typography, Box } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { green, pink } from "../../shared/colours";

const SidebarMenuItem = (props) => {

	let location = useLocation();
	
	let itemlabelStyle = {
		height: "2em",
		transform: "scale(1)",
		textAlign: "right",
		transformOrigin: "right bottom",
		transition: "all 0.1s linear",
		color: "text.secondary",
		fontWeight: "bold",
		fontSize: "1.2em",
	};
	
	let underlineStyle = {
		width: "5.5em",
		position: "absolute",
		top: "2.7em",
		left: "11em",
		borderBottom: "solid 2px",
		borderColor: "text.menuUnderline",
		zIndex: "99",
		overflow: "visible !important",
		transition: "all 0.3s",
	};
	
	let endCircleStyle = {
		width: "0.4em",
		height: "0.4em",
		border: "solid 2px",
		borderRadius: "100%",
		borderColor: "text.menuUnderline",
		position: "absolute",
		top: "2.55em",
		left: "10.6em",
		transition: "all 0.3s",
	};
	
	let endCircleTickStyle = {
		width: "0.4em",
		height: "0.4em",
		border: "solid 2px",
		borderRadius: "100%",
		borderColor: "text.menuUnderline",
		position: "absolute",
		top: "-0.1em",
		left: "1.9em",
		transition: "all 0.3s",
	};
	
	let underlineTickStyle = {
		width: "2em",
		position: "absolute",
		top: "2em",
		left: "16.2em",
		transform: "rotate(-45deg)",
		borderBottom: "solid 2px",
		borderColor: "text.menuUnderline",
		zIndex: "99",
		overflow: "visible !important",
		transition: "all 0.3s",
	};
	
	let buttonStyle = {
		width: "100%",
		height: "4em",
		marginBottom: "1em",
		textAlign: "right",
		verticalAlign: "bottom",
		background: "transparent",
		'&:hover': {
			background: "transparent",
			"& .underline": {
				left: "10em",
				width: "8em",
			},
			"& .endCircle": {
				left: "9.6em",
			},
			"& .endCircleTick": {
				left: "2.9em",
			},
			"& .underlineTick": {
				left: "17.5em",
				top: "1.65em",
				width: "3em"
			},
			"& .itemlabel": {
				transform: "scale(1.1)",
				color: "text.menuItemSelected",
				textShadow: `
					0 0 7px ${green},
					0 0 10px ${green},
					0 0 21px ${green},
					0 0 42px ${green},
					0 0 82px ${green},
					0 0 92px ${green}`
			}
		},
		'&.Mui-selected': {
			background: "transparent",
			'&:hover': {
				background: "transparent",
			},
			"& .endCircle": {
				border: `solid 2px ${pink}`,
				left: "9.6em",
			},
			"& .endCircleTick": {
				border: `solid 2px ${pink}`,
				left: "2.9em",
			},
			"& .underline": {
				borderBottom: `solid 2px ${pink}`,
				left: "10em",
				width: "9em",
			},
			"& .underlineTick": {
				borderBottom: `solid 2px ${pink}`,
				left: "18.5em",
				top: "1.65em",
				width: "3em"
			},
			"& .itemlabel": {
				transform: "scale(1.1)",
				color: "text.menuItemSelected",
				textShadow: `
					0 0 7px ${green},
					0 0 10px ${green},
					0 0 21px ${green},
					0 0 42px ${green},
					0 0 82px ${green},
					0 0 92px ${green}`
			}
		}
	}
	
	return (
		<ListItemButton
			component={Link}
			to={props.path}
			selected={location.pathname === props.path || location.pathname === props.alternatepath}
			sx={buttonStyle}
		>
			<Stack direction="column" justifyContent="right" sx={{width: "100%"}}>
				<Typography className="itemlabel" sx={itemlabelStyle}>
					{props.label}
				</Typography>
				<Box className="underline" sx={underlineStyle}></Box>
				<Box className="endCircle" sx={endCircleStyle}></Box>
				<Box className="underlineTick" sx={underlineTickStyle}>
					<Box className="endCircleTick" sx={endCircleTickStyle}></Box>
				</Box>
			</Stack>
		</ListItemButton>
	);

}

export default SidebarMenuItem;